export default {"src":"/pro/_next/static/media/blast.f3c398ba.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};